import { styled } from '@abyss/web/tools/styled';
import { Box } from '@abyss/web/ui/Box';
import { Flex } from '@abyss/web/ui/Flex';

export const ProviderInfoCard = styled(Flex, {
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.12)',
  backgroundColor: '$white !important',
  border: ' 1px solid #E5E5E6',
  alignItems: 'center',
  padding: '12px 10px',
  borderRadius: '8px',
  flexWrap: 'nowrap',
  '.abyss-flex-root': {
    textAlign: 'center',
  },
  '@screen >= $md': {
    width: '408px',
  },
  '@screen < $md': {
    display: 'flex',
    width: '90%',
  },
});

export const ProviderInfoCardContainer = styled(Flex, {
  '@screen < $md': {
    marginTop: '20px',
  },
});
export const CareTeamCardRow = styled(Box, {
  display: 'flex!important',
  backgroundColor: 'transparent !important',
  width: '184px!important',
  padding: '0px 12px !important',
  flexDirection: 'column!important',
  justifyContent: 'center!important',
  alignItems: 'flex-start!important',
});

export const MapViewWrapper = styled('div', {
  borderBottom: '1px solid $greyBorderColor',
});

export const MapContainer = styled('div', {
  maxWidth: '1520px',
  marginLeft: 'auto',
  paddingTop: '$sm',
  paddingLeft: '$lg',
  paddingRight: '$lg',
});

export const HeaderContainer = styled('div', {
  backgroundColor: '$bgProviderDetailsColor',
  maxWidth: '1520px',
  marginLeft: 'auto',
  paddingTop: '$sm',
  paddingLeft: '$lg',
  paddingRight: '$lg',
});

export const HeaderPageWrapper = styled('div', {
  backgroundColor: '$bgHeaderColor',
  paddingBottom: '20px !important',
  borderBottom: '1px solid $greyBorderColor',
});
